// extracted by mini-css-extract-plugin
export default {"table-body":"a5UGs6TE2MW7Cc8"};